module.exports = __webpack_public_path__ + "static/media/iStock-1292243111.e71b2601.jpg";